import React, { useState } from 'react';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';
import DrawerItem from './DrawerItem';
import { MdClose } from 'react-icons/md';
import { pushToDataLayer, toGa4CartItem } from '@/features/gtm/gtmUtils';

// Define the props the component will accept
interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const CartDrawer: React.FC<CartDrawerProps> = ({ isOpen, onClose }) => {
  const { items } = useAppSelector((state) => state.cart);
  const total = items.reduce(
    (acc, curr) => acc + curr.price * curr.quantity,
    0
  );

  const handleBeginCheckout = () => {
    pushToDataLayer('begin_checkout', {
      ecommerce: {
        value: total,
        currency: 'BDT',
        items: items.map((item) =>
          toGa4CartItem(item),
        ),
      },
    });
    onClose();
  };


  return (
    <>
      {/* The dark overlay */}
      <div
        className={`cart-overlay ${isOpen ? 'is-visible' : ''}`}
        onClick={onClose}
      />

      {/* The drawer panel */}
      <div className={`mobile-cart ${isOpen ? 'is-open' : ''}`}>
        <div className="dropdownmenu-wrapper">
          <div className="dropdown-cart-header">
            <span>Shopping Cart</span>
            <button className="btn-close" onClick={onClose} aria-label="Close">
              <MdClose />
            </button>
          </div>

          {items?.length === 0 && (
            <div className="d-flex align-items-center h-100">
              <div>
                <p>Your cart is currently empty.</p>
                <Link
                  href="/shop"
                  className="trk-btn trk-btn--primary w-100"
                  onClick={onClose}
                >
                  Continue Shopping
                </Link>
              </div>
            </div>
          )}

          {items?.length > 0 && (
            <div className="dropdown-cart-products">
              {items?.map((product: any) => (
                <DrawerItem key={product?.id} product={product} />
              ))}
            </div>
          )}

          {items?.length > 0 && (
            <div className="dropdown-cart-total">
              <span>SUBTOTAL:</span>
              <span className="cart-total-price">৳{total.toFixed(2)}</span>
            </div>
          )}

          {items?.length > 0 && (
            <div className="dropdown-cart-action">
              <Link
                href="/cart"
                className="trk-btn trk-btn--outline w-100"
                onClick={onClose}
              >
                View Cart
              </Link>
              <Link
                href={items?.length > 0 ? '/checkout' : '#'}
                className="trk-btn trk-btn--primary disable"
                onClick={handleBeginCheckout}
              >
                Checkout
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CartDrawer;
